import { SectionAuditLogTable } from "./SectionAuditLogTable";
import { SectionFiltersAndSearch } from "./SectionFiltersAndSearch";

export const AuditLogOverview = () => {
  return (
    <div
      data-testid="audit-log-overview-table-container"
      className="mt-3 rounded-md bg-white p-4 shadow-[0_4px_20px_0_rgba(0,0,0,0.1)]"
    >
      <SectionFiltersAndSearch />
      <SectionAuditLogTable />
    </div>
  );
};
